import readBooleanEnv from './services/readBooleanEnv';

export const DISABLE_FASTLY_CHALLENGE_COOKIE_NAME = 'disable-fastly-challenge';

const fastlyChallengeEnabled: boolean = readBooleanEnv(process.env.FASTLY_CHALLENGE_ENABLED);

export default fastlyChallengeEnabled;
